import NewReferral from './NewReferral';

export default NewReferral;
